import { AudioFile } from '../types';

/**
 * 加载 public/audio/others 目录下的所有音频文件
 * @returns 音频文件数组
 */
export const loadOtherAudios = async (): Promise<AudioFile[]> => {
  try {
    // 获取目录列表
    const response = await fetch('/audio/others/index.json');
    
    // 如果 index.json 不存在，返回空数组
    if (!response.ok) {
      console.warn('No index.json found in /audio/others directory');
      return [];
    }
    
    const fileList = await response.json();
    
    // 将文件列表转换为 AudioFile 对象数组
    return fileList.map((filename: string) => ({
      name: getDisplayName(filename),
      path: `/audio/others/${filename}`,
      category: 'other'
    }));
  } catch (error) {
    console.error('Error loading other audio files:', error);
    return [];
  }
};

/**
 * 从文件名中提取显示名称（去除扩展名）
 */
const getDisplayName = (filename: string): string => {
  return filename.replace(/\.[^/.]+$/, ''); // 移除文件扩展名
};